/**
 * PersistenceService - 永続化処理を管理
 */

import type { AppState } from '../types'
import { logger } from '../../lib/logger'

export class PersistenceService {
  private persistenceKey = 'paraparaview_graph_v2'
  private saveTimer: NodeJS.Timeout | null = null

  /**
   * localStorageに永続化
   */
  persist(state: AppState, crdtState?: number[]): void {
    try {
      const serialized = JSON.stringify({
        appState: state,
        ydocState: crdtState
      })
      localStorage.setItem(this.persistenceKey, serialized)
    } catch (error) {
      logger.error('[PersistenceService] Failed to persist:', error)
    }
  }

  /**
   * localStorageから復元
   */
  restore(): { appState: AppState; ydocState?: number[] } | null {
    try {
      const stored = localStorage.getItem(this.persistenceKey)
      if (!stored) return null
      
      const { appState, ydocState } = JSON.parse(stored) as {
        appState: AppState
        ydocState?: number[]
      }
      
      // 日付の復元
      appState.meta.lastModified = new Date(appState.meta.lastModified)
      Object.values(appState.imageSets).forEach(set => {
        set.createdAt = new Date(set.createdAt)
      })
      Object.values(appState.setItems).forEach(item => {
        if (item.metadata?.capturedAt) {
          item.metadata.capturedAt = new Date(item.metadata.capturedAt)
        }
      })
      
      return { appState, ydocState }
    } catch (error) {
      logger.error('[PersistenceService] Failed to restore:', error)
      return null
    }
  }

  /**
   * デバウンス付き自動保存を設定
   */
  setupAutoSave(saveCallback: () => void, delay = 1000): () => void {
    return () => {
      if (this.saveTimer) clearTimeout(this.saveTimer)
      this.saveTimer = setTimeout(() => {
        saveCallback()
      }, delay)
    }
  }

  /**
   * ストレージをクリア
   */
  clear(): void {
    localStorage.removeItem(this.persistenceKey)
    if (this.saveTimer) {
      clearTimeout(this.saveTimer)
      this.saveTimer = null
    }
  }
}